/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';

interface LogoProps {
  variant?: 'full' | 'icon' | 'light' | 'white';
  className?: string;
  height?: number | string;
}

export const Logo: React.FC<LogoProps> = ({
  variant = 'full',
  className = '',
  height = 50,
}) => {
  const getLogoSrc = () => {
    if (variant === 'light' || variant === 'white') {
      return '/logo_docarn_blanc.png';
    }
    if (variant === 'icon') {
      return '/icon_docarn.png';
    }
    return '/logo_docarn.png';
  };

  return (
    <img
      src={getLogoSrc()}
      alt="Docarn Juridique"
      className={`w-auto select-none pointer-events-none ${className}`}
      style={{ height }}
      draggable={false}
    />
  );
};

